function oPushEngine(engine) {
  this.engine = engine;
}

oPushEngine.prototype = {
  // app推送
  app: function (data, callback) {
    // 请求后台八爪鱼推送。
    this.engine.request.api.post("/ESB/Tools/Push/App", data,
      // 处理回调事件，通过分析data.status.code的状态来实现。
      function (returnData) {
        callback(returnData);
      });

    // this.octopus.push.app({userList: [1], title: "哈哈哈2222", content: "测试单独发送。"}, function (data) {
    //   alert(JSON.stringify(data));
    // });
    // this.octopus.push.app({title: "有待派发的工单提交给您22222", content: "测试单独发送0000000"}, function (data) {
    //   alert(JSON.stringify(data));
    // });
  },
  // 短信推送
  sms: function (data, callback) {
    // 请求后台八爪鱼推送。
    this.engine.request.api.post("/ESB/Services/Push/SMS", data,
      // 处理回调事件，通过分析data.status.code的状态来实现。
      function (returnData) {
        callback(returnData);
      });
  },
  email: function (data, callback) {
    // 请求后台八爪鱼推送。
    this.engine.request.api.post("/ESB/Services/Push/Email", data,
      // 处理回调事件，通过分析data.status.code的状态来实现。
      function (returnData) {
        callback(returnData);
      });
  }
}


export {
  oPushEngine
}





// WEBPACK FOOTER //
// ./src/assets/octopus/engine/push.js